import React from "react";
import Navigation from "./Navigation/Navigation";
import "./App.css";
import "./Styles/DesignSystem.css";

function App() {
  return (
    <div>
      <Navigation />
    </div>
  );
}

export default App;
